var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { injectable } from 'inversify';
import printJS from 'print-js';
import { PDFDocument } from 'pdf-lib';
import fontkit from '@pdf-lib/fontkit';
let PrintService = class PrintService {
    /**
     * Вывести файлы на печать
     *
     * @param files - Массив файлов в формате Blob
     * @returns Promise, разрешающийся после открытия диалога печати
     */
    print(files) {
        return __awaiter(this, void 0, void 0, function* () {
            const mergedPdf = yield PDFDocument.create();
            const fontUrl = '/Roboto-Regular.ttf';
            const fontBytes = yield fetch(fontUrl).then((res) => res.arrayBuffer());
            for (const file of files) {
                const pdfDoc = yield PDFDocument.load(yield file.arrayBuffer());
                pdfDoc.registerFontkit(fontkit);
                const font = yield pdfDoc.embedFont(fontBytes);
                const form = pdfDoc.getForm();
                form.updateFieldAppearances(font);
                form.flatten();
                const copiedPages = yield mergedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
                copiedPages.forEach((page) => mergedPdf.addPage(page));
            }
            const document = yield mergedPdf.save();
            return new Promise((resolve, reject) => {
                printJS({
                    printable: URL.createObjectURL(new window.Blob([document], {
                        type: 'application/pdf',
                    })),
                    onPdfOpen: () => resolve(null),
                    onPrintDialogClose: () => resolve(null),
                    onError: (error) => reject(error),
                });
            });
        });
    }
};
PrintService = __decorate([
    injectable()
], PrintService);
export { PrintService };
